import { useMemo } from "react";

export const useHistoryMap = (parsedModels: any[]) => {
  return useMemo(() => {
    const uniqueIds = Array.from(new Set(parsedModels.map((m: any) => m.trainHistory_id).filter(Boolean))).sort(
      (a, b) => a - b,
    );

    return uniqueIds.map((trainHistory_id, index) => {
      // round 로딩 전엔 목록 순번으로 fallback
      const round = parsedModels.find((m) => m.trainHistory_id === trainHistory_id)?.round ?? index + 1;
      return {
        trainHistory_id,
        round,
        label: `${round}회차`,
        models: parsedModels.filter((m) => m.trainHistory_id === trainHistory_id).sort((a, b) => a.epoch - b.epoch),
      };
    });
  }, [parsedModels]);
};
